import { Divider, makeStyles, Typography } from '@material-ui/core'
import { MoneyString } from 'model/Money'
import { QuantityString } from 'model/Quantity'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TargetPriceGraphData } from '../../useBomItemDetails'
import { TargetPriceTooltipListItemText } from './TargetPriceTooltipListItemText'

const useStyles = makeStyles((theme) => ({
  header: { padding: theme.spacing(1), textAlign: 'center' },
  fields: {
    textAlign: 'right',
  },
  divider: {
    margin: theme.spacing(0, -2),
  },
}))

export const MaterialTooltip = (props: { data: TargetPriceGraphData }) => {
  const { t } = useTranslation()

  const classes = useStyles()

  return (
    <div>
      <div className={classes.header}>
        <Typography>{props.data.description}</Typography>
        <Typography variant="caption">
          {props.data.id} -{' '}
          {`${QuantityString(
            props.data.staggeredTotalQuantity
          )} - ${QuantityString(props.data.totalQuantity)}`}
        </Typography>
      </div>
      <div className={classes.fields}>
        <TargetPriceTooltipListItemText
          primary={MoneyString(props.data.mainActivityCostPrice)}
          secondary={t('project:cost-price')}
        />

        <TargetPriceTooltipListItemText
          primary={MoneyString(props.data.surchargeValue)}
          secondary={t('common:surcharge')}
        />
        <TargetPriceTooltipListItemText
          primary={`-${MoneyString(props.data.discountValue)}`}
          secondary={t('common:discount')}
          color="secondary"
        />
        <Divider style={{ margin: '0 -1rem' }} />

        <TargetPriceTooltipListItemText
          primary={MoneyString(props.data.total)}
          secondary={t('project:sales-price')}
        />
      </div>
      {/* <pre>{JSON.stringify(props.data, null, 2)}</pre> */}
    </div>
  )
}
